<div class="loren-asset-details-analysis-box">
  <h3 class="loren-asset-details-analysis-name">
    {{ metering().description }}
  </h3>
  <mat-tab-group
    class="loren-asset-details-analysis-tabs"
    mat-align-tabs="start"
    mat-stretch-tabs="true"
    [disableRipple]="true"
    [selectedIndex]="activeTab()"
    (selectedIndexChange)="handleActiveTabChange($event)">
    <mat-tab [label]="'asset_details.week' | transloco">
      <div class="loren-asset-details-analysis-controls" style="display: flex">
        <mat-icon (click)="subtract('week')">keyboard_arrow_left</mat-icon>
        <span>
          {{ previousWeek().start | lorenDate : weekFormat }} -
          {{ previousWeek().end | lorenDate : weekFormat }}
        </span>
        <mat-icon
          [ngClass]="{
            'loren-asset-details-analysis-controls--disabled-icon':
              compareDates(previousWeek().end, initialEndWeek)
          }"
          (click)="add('week')"
          >keyboard_arrow_right</mat-icon
        >
      </div>
      @if(loading()) {
      <mat-spinner></mat-spinner>
      } @else if(error()) {
      {{ "error_page.general_error_message" | transloco }}
      } @else {
      <div class="loren-asset-details-analysis-values">
        <div class="loren-asset-details-analysis-values-item">
          <span class="loren-asset-details-analysis-values-label">
            {{ "asset_details.min" | transloco }}
          </span>
          @if(min()) {
          <span class="loren-asset-details-analysis-values-value">
            {{ min() | lorenNumber : 2 }} {{ unit() }}
          </span>
          } @else {
          <p class="loren-asset-details-analysis-values-none">
            {{ "asset_details.no_info_for_period" | transloco }}
          </p>
          }
        </div>
        <div class="loren-asset-details-analysis-values-item">
          <span class="loren-asset-details-analysis-values-label">
            {{ "asset_details.average" | transloco }}
          </span>
          @if(avg()) {
          <span class="loren-asset-details-analysis-values-value">
            {{ avg() | lorenNumber : 2 }} {{ unit() }}
          </span>
          } @else {
          <p class="loren-asset-details-analysis-values-none">
            {{ "asset_details.no_info_for_period" | transloco }}
          </p>
          }
        </div>
        <div class="loren-asset-details-analysis-values-item">
          <span class="loren-asset-details-analysis-values-label">
            {{ "asset_details.max" | transloco }}
          </span>
          @if(max()) {
          <span class="loren-asset-details-analysis-values-value">
            {{ max() | lorenNumber : 2 }} {{ unit() }}
          </span>
          } @else {
          <p class="loren-asset-details-analysis-values-none">
            {{ "asset_details.no_info_for_period" | transloco }}
          </p>
          }
        </div>
      </div>
      <div class="loren-asset-details-analysis-insight">
        <div class="loren-asset-details-analysis-insight-icon">
          <mat-icon [svgIcon]="icon()"></mat-icon>
        </div>
        <p>
          {{ insight() || ("asset_details.no_info_for_period" | transloco) }}
        </p>
      </div>
      }
    </mat-tab>
    <mat-tab [label]="'asset_details.month' | transloco">
      <div class="loren-asset-details-analysis-controls" style="display: flex">
        <mat-icon (click)="subtract('month')">keyboard_arrow_left</mat-icon>
        <span>{{ previousMonth() | lorenDate : monthFormat }}</span>
        <mat-icon
          [ngClass]="{
            'loren-asset-details-analysis-controls--disabled-icon':
              compareDates(previousMonth(), initialMonth)
          }"
          (click)="add('month')"
          >keyboard_arrow_right</mat-icon
        >
      </div>
      @if(loading()) {
      <div style="display: flex; align-items: center">
        <mat-spinner></mat-spinner>
      </div>
      } @else if(error()) {
      {{ "error_page.general_error_message" | transloco }}
      } @else {
      <div class="loren-asset-details-analysis-values">
        <div class="loren-asset-details-analysis-values-item">
          <span class="loren-asset-details-analysis-values-label">
            {{ "asset_details.min" | transloco }}
          </span>
          @if(min()) {
          <span class="loren-asset-details-analysis-values-value">
            {{ min() | lorenNumber : 2 }} {{ unit() }}
          </span>
          } @else {
          <p class="loren-asset-details-analysis-values-none">
            {{ "asset_details.no_info_for_period" | transloco }}
          </p>
          }
        </div>
        <div class="loren-asset-details-analysis-values-item">
          <span class="loren-asset-details-analysis-values-label">
            {{ "asset_details.average" | transloco }}
          </span>
          @if(avg()) {
          <span class="loren-asset-details-analysis-values-value">
            {{ avg() | lorenNumber : 2 }} {{ unit() }}
          </span>
          } @else {
          <p class="loren-asset-details-analysis-values-none">
            {{ "asset_details.no_info_for_period" | transloco }}
          </p>
          }
        </div>
        <div class="loren-asset-details-analysis-values-item">
          <span class="loren-asset-details-analysis-values-label">
            {{ "asset_details.max" | transloco }}
          </span>
          @if(max()) {
          <span class="loren-asset-details-analysis-values-value">
            {{ max() | lorenNumber : 2 }} {{ unit() }}
          </span>
          } @else {
          <p class="loren-asset-details-analysis-values-none">
            {{ "asset_details.no_info_for_period" | transloco }}
          </p>
          }
        </div>
      </div>
      <div class="loren-asset-details-analysis-insight">
        <div class="loren-asset-details-analysis-insight-icon">
          <mat-icon [svgIcon]="icon()"></mat-icon>
        </div>
        <p>
          {{ insight() || ("asset_details.no_info_for_period" | transloco) }}
        </p>
      </div>
      }
    </mat-tab>
  </mat-tab-group>
</div>
